import gql from 'graphql-tag'

export const USUARIO_BY_EMAIL_QUERY = gql`
  query UsuarioByEmailQuery($email: String!) {
    usuarioByEmail(email: $email) {
      id
      nome
      email
    }
  }
`
